import { Box, Typography } from '@mui/material';

type AddCustomRuleFieldProps = {
  label: string;
  children?: React.ReactNode;
};

const AddCustomRuleField = ({ label, children }: AddCustomRuleFieldProps) => {
  return (
    <Box>
      <Typography variant="body1">{label}</Typography>
      {children}
    </Box>
  );
};

export default AddCustomRuleField;
